// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "18b35b03e6eb5e53ea4b" + ".chunk.js";
};